module.exports = __webpack_public_path__ + "img/icon-scene.ac54a2af.svg";